import { normalizePhoneNumber, isValidPhoneNumber, phoneNumberValidator } from '../../../../core/validators/phone-number';
import { Component , OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {Router} from '@angular/router';
import {fuseAnimations} from '../../../../core/animations';
import {TranslateService} from '@ngx-translate/core';
import {FrontUserService} from '../../../../core/services/frontUsers.service';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {checkEmailOnServer , emailValidator} from '../../../../core/validators/validators';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import {ToastrService } from 'ngx-toastr';
import {FuseMailDialogComponent} from '../../../../core/components/mail-dialog/mail-dialog.component';
import {FuseConfigService} from '../../../../core/services/config.service';

@Component({
    selector: 'frontuser-new-page',
    templateUrl: './frontuser-new.component.html',
    styleUrls: ['./frontuser-new.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FrontUserNewComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    frontRoleId: new FormControl('', Validators.required),
    firstName: new FormControl({value: '', disabled: true}, Validators.required),
    lastName: new FormControl({value: '', disabled: true}, Validators.required),
    nickName: new FormControl({value: '', disabled: true}),
    email: new FormControl({value: '', disabled: true}, [emailValidator , checkEmailOnServer]),
    countryId: new FormControl({value: '', disabled: true}, Validators.required),
    cityId: new FormControl({value: '', disabled: true}, Validators.required),
    organizationId: new FormControl({value: '', disabled: true}, Validators.required),
    tagId: new FormControl({value: '', disabled: true}),
    lang: new FormControl({value: '', disabled: true}, Validators.required),
    gender: new FormControl({value: '', disabled: true}, Validators.required),
    street: new FormControl({value: '', disabled: true}),
    number: new FormControl({value: '', disabled: true}),
    postcode: new FormControl({value: '', disabled: true}),
    cityLocation: new FormControl({value: '', disabled: true}),
    phone: new FormControl({value: '', disabled: true}, phoneNumberValidator),
    mobile: new FormControl({value: '', disabled: true}, phoneNumberValidator),
    dateOfBirth: new FormControl({value: '', disabled: true}),
    abschlussjahr: new FormControl({value: '', disabled: true}),
    dateOfBaptism: new FormControl({value: '', disabled: true}),
    dateOfConfirmation: new FormControl({value: '', disabled: true}),
    introdactionDate: new FormControl({value: '', disabled: true}),
    targetGroupId: new FormControl({value: '', disabled: true}),
    status: new FormControl({value: '', disabled: true}),
    confessionId: new FormControl({value: '', disabled: true}),
    notes: new FormControl({value: '', disabled: true}),
    showFoto: new FormControl({value: '', disabled: true}),
    showChildrenName: new FormControl({value: '', disabled: true}),
    showNick: new FormControl({value: '', disabled: true}),
    isMember: new FormControl({value: '', disabled: true}),
    loginType: new FormControl({value: '', disabled: true}),
    platformId: new FormControl({value: '', disabled: true})
  });
  public languages = [ {label: 'English' , value: 'en'} , {label: 'Deutsch' , value: 'de'}, {label: 'Français' , value: 'fr'} ];
  public genders = [ {label: 'Mann' , value: 'male'} , {label: 'Frau' , value: 'female'}, {label: 'Divers', value: 'diverse'} ];

  public img: any = '';
  public uploadedImg = null;
  public countries = [];
  public cities = [];
  public targetGroups = [];
  public organizations = [];
  public tags = [];
  public roles = [];
  public levelStatuses = [];
  public confessions = [];
  public showLoginType = false;
  platformId;
  isOrganizer = false;
  noOrganization = false;
  guestOrganization;
  platforms = [];

  constructor (private userService: FrontUserService , private router: Router ,
               public translate: TranslateService , private organizationService: OrganizationsService ,
               public dialog: MatDialog , public snackBar: MatSnackBar, public toastr: ToastrService,
               private fuseConfig: FuseConfigService) {
      this.organizationService.getCountry().subscribe((result: any) => {
        this.countries = result;
        this.userService.getRoles().subscribe((roleResult: any) => {
          this.roles = [];
          for (let i = 0; i < roleResult.length; i++) {
            let translation = 'main._' + roleResult[ i ].name;
            this.roles.push({value: roleResult[ i ].id ,
              label: translation});
          }
          this.userService.getLevelStatus().subscribe((levelResult: any) => {
            this.levelStatuses = [];
            for (let i = 0; i < levelResult.length; i++) {
              if (levelResult[ i ].status) {
                this.levelStatuses.push({value: levelResult[ i ].id , label: (levelResult[ i ].level + '/' + levelResult[ i ].status)});
              } else {
                this.levelStatuses.push({value: levelResult[ i ].id , label: (levelResult[ i ].level)});
              }
            }
            this.userService.getTargetGroup(false).subscribe((targetResults: any) => {
              this.targetGroups = [];
              for (let i = 0; i < targetResults.targetGroups.length; i++) {
                this.targetGroups.push({
                  value: targetResults.targetGroups[ i ].id ,
                  label: ((('0' + targetResults.targetGroups[ i ].targetNumber).slice(-2)) + ' - ' + targetResults.targetGroups[ i ].ageMask)
                });
              }
              this.userService.getConfession().subscribe((confessioResults: any) => {
                this.confessions = confessioResults;
                this.initForm();
              });
            });
          });
        });
      });
    this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        this.platformId = res.id;
        this.formGroup.patchValue({platformId: this.platformId});
      }
    });
    this.fuseConfig.role.subscribe(res => {
      this.isOrganizer = res && res === 'organisationAdmin';
    });
  }

  checkNoOrganization(event) {
    if (!this.guestOrganization && event) {
      this.organizationService.getGuestOrganization().subscribe({
        next: (result: any) => {
          if (result) {
            this.guestOrganization = result;
          }
        },
        error: (err: any) => {}
      });
    }
  }

  ngOnInit () {
    // this.initForm();
  }

  initForm () {
    this.formGroup.patchValue({lang: 'de'});
    this.formGroup.get('email').valueChanges.subscribe(res => {
      const errors = this.formGroup.controls.email.errors;
      if (!errors && res) {
        this.userService.checkEmailValid(res).subscribe((data: any) => {
          if (data.user) {
            this.formGroup.controls.email.setErrors({checkEmailOnServer: true});
          }
        });
      }
    });
    this.formGroup.get('countryId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          if (this.cities.length === 1) {
            this.formGroup.patchValue({cityId: this.cities[ 0 ].id});
          } else {
            this.formGroup.patchValue({cityId: null});
          }
        });
      }
    });

    this.formGroup.get('cityId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          if (this.organizations.length === 1) {
            this.formGroup.patchValue({organizationId: this.organizations[ 0 ].id});
          } else {
            this.formGroup.patchValue({organizationId: null});
          }
        });
      }
    });
    this.formGroup.get('organizationId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getTagByOrganization(res).subscribe((result: any) => {
          this.tags = [];
          this.tags.push({value: null, label: '-'});
          for (let i = 0; i < result.length; i++) {
            this.tags.push({value: result[ i ].id , label: result[ i ].name});
          }
          this.formGroup.patchValue({tagId: null});
        });
        this.organizationService.checkOrganizationPlatform(res).subscribe((result: any) => {
          this.showLoginType = !!result;
        });
        this.organizationService.getPlatformsByOrganizationId(res).subscribe((result: any) => {
          this.platforms = [];
          for (let i = 0; i < result.length; i++) {
            let index = this.platforms.findIndex(p => +p.id === +result[i].platformId);
            if (index === -1 && result[i].platform) {
              this.platforms.push(result[i].platform);
            }
          }
        });
      }
    });

    this.formGroup.get('frontRoleId').valueChanges.subscribe((res) => {
      const selectControlCountry = this.formGroup.get('countryId');
      const selectControlConfession = this.formGroup.get('confessionId');
      const selectControlTargetGroup = this.formGroup.get('targetGroupId');
      const selectControlCanton = this.formGroup.get('cityId');
      const selectControlOrganization = this.formGroup.get('organizationId');
      const selectControlTag = this.formGroup.get('tagId');
      const selectControlGender = this.formGroup.get('gender');
      const inputControlFirstName = this.formGroup.get('firstName');
      const inputControlLastName = this.formGroup.get('lastName');
      const inputControlNickName = this.formGroup.get('nickName');
      const inputControlStreet = this.formGroup.get('street');
      const inputControlNumber = this.formGroup.get('number');
      const inputControlPostcode = this.formGroup.get('postcode');
      const inputControlCity = this.formGroup.get('cityLocation');
      const inputControlPhone: any = this.formGroup.get('phone');
      const inputControlMobile: any = this.formGroup.get('mobile');
      const inputControlEmail = this.formGroup.get('email');
      const inputControlDateOfBirth = this.formGroup.get('dateOfBirth');
      const inputControlDateOfBaptism = this.formGroup.get('dateOfBaptism');
      const inputControlIntrodactionDate = this.formGroup.get('introdactionDate');
      const inputControlDateOfConfirmation = this.formGroup.get('dateOfConfirmation');
      const inputControlNotes = this.formGroup.get('notes');
      const inputControlAbschlussjahr = this.formGroup.get('abschlussjahr');
      const inputControlStatus = this.formGroup.get('status');
      const checkboxControlShowFoto = this.formGroup.get('showFoto');
      const checkboxControlShowChildrenName = this.formGroup.get('showChildrenName');
      const checkboxControlShowNick = this.formGroup.get('showNick');
      const chexboxControlIsMember = this.formGroup.get('isMember');
      const radioControlLoginType = this.formGroup.get('loginType');
      const selectControlPlatform = this.formGroup.get('platformId');

      if (res === 1) {
        if (this.countries.length === 1) {
          selectControlCountry.disable({emitEvent: false});
        } else {
          selectControlCountry.enable({emitEvent: false});
        }
        if (this.cities.length === 1) {
          selectControlCanton.disable({emitEvent: false});
        } else {
          selectControlCanton.enable({emitEvent: false});
        }
        selectControlOrganization.enable({emitEvent: false});
        selectControlTag.enable();
        inputControlFirstName.enable();
        inputControlLastName.enable();
        inputControlNickName.enable();
        inputControlEmail.enable({emitEvent: false});
        selectControlGender.enable();
        inputControlStreet.enable();
        inputControlNumber.enable();
        inputControlPostcode.enable();
        inputControlCity.enable();
        inputControlPhone.enable();
        inputControlMobile.enable();
        inputControlDateOfBirth.enable();

        inputControlDateOfBaptism.enable();
        inputControlIntrodactionDate.enable();
        inputControlDateOfConfirmation.enable();
        inputControlNotes.enable();
        inputControlAbschlussjahr.enable();
        inputControlStatus.enable();
        selectControlTargetGroup.enable();
        selectControlConfession.enable();
        checkboxControlShowFoto.enable();
        checkboxControlShowChildrenName.enable();
        checkboxControlShowNick.enable();
        this.formGroup.patchValue({targetGroupId: ''});
        chexboxControlIsMember.enable();
        radioControlLoginType.enable();
        selectControlPlatform.enable();
        // this.formGroup.patchValue({loginType: 'parent'});
      } else if (res === 2) {
        selectControlTag.enable();
        inputControlNotes.enable();
        if (this.countries.length === 1) {
          selectControlCountry.disable({emitEvent: false});
        } else {
          selectControlCountry.enable({emitEvent: false});
        }
        if (this.cities.length === 1) {
          selectControlCanton.disable({emitEvent: false});
        } else {
          selectControlCanton.enable({emitEvent: false});
        }
        selectControlOrganization.enable({emitEvent: false});
        inputControlFirstName.enable();
        inputControlLastName.enable();
        inputControlNickName.disable();
        inputControlEmail.enable({emitEvent: false});

        selectControlGender.enable();
        inputControlStreet.enable();
        inputControlNumber.enable();
        inputControlPostcode.enable();
        inputControlCity.enable();
        inputControlPhone.enable();
        inputControlMobile.enable();
        inputControlDateOfBirth.enable();

        inputControlDateOfBaptism.disable();
        inputControlIntrodactionDate.disable();
        inputControlDateOfConfirmation.disable();
        inputControlAbschlussjahr.disable();
        inputControlStatus.enable();
        selectControlTargetGroup.disable();
        selectControlConfession.enable();
        checkboxControlShowFoto.disable();
        checkboxControlShowChildrenName.disable();
        checkboxControlShowNick.disable();
        this.formGroup.patchValue({targetGroupId: this.targetGroups[ this.targetGroups.length - 1 ].value});
        chexboxControlIsMember.enable();
        radioControlLoginType.enable();
        selectControlPlatform.enable();
        // this.formGroup.patchValue({loginType: ''});
      }
    });

    this.formGroup.get('email').valueChanges.subscribe(res => {
      const errors = this.formGroup.controls.email.errors;
      if (!errors) {
        this.userService.checkEmailValid(res).subscribe((data: any) => {
          if (!data.valid) {
            this.formGroup.controls.email.setErrors({checkEmailOnServer: true});
          }
        });
      }
    });
    if (this.countries.length === 1) {
      this.formGroup.patchValue({countryId: this.countries[ 0 ].id});
    }
  }

  addUser () {
    let _email  = this.formGroup.value.email;
    if (_email) {
      const dialogRef = this.dialog.open(FuseMailDialogComponent, {
        panelClass: 'unsave-form-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.sendForm(result);
        }
      });
    } else {
      this.sendForm('no');
    }
  }

  checkUserLogin(data) {
    if (data.loginType === 'email' && !data.email) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('frontUser.emptyEmailError');
      this.toastr.error(msg, title);
      return false;
    }
    if (data.loginType === 'mobile' && !data.mobile) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('frontUser.emptyMobileError');
      this.toastr.error(msg, title);
      return false;
    }
    return true;
  }

  sendForm (result) {
    const data = this.formGroup.getRawValue();
    data.file = this.uploadedImg;
    if (result === 'yes') {
      data.sendInvite = true;
    }
    if (result === 'no') {
      data.sendInvite = false;
    }
    const selectControlTargetGroup = this.formGroup.get('targetGroupId');
    selectControlTargetGroup.enable();
    if (data.phone) {
      data.phone = normalizePhoneNumber(data.phone);
    }
    if (data.mobile) {
      data.mobile = normalizePhoneNumber(data.mobile);
    }
    if (data.dateOfBirth) {
      data.dateOfBirth = moment(data.dateOfBirth).format('DD.MM.YYYY');
    }
    if (data.dateOfBaptism) {
      data.dateOfBaptism = moment(data.dateOfBaptism).format('DD.MM.YYYY');
    }
    if (this.guestOrganization && this.noOrganization && +this.platformId === 6) {
      data.cityId = +this.guestOrganization.cityId;
      data.organizationId = this.guestOrganization.id;
    }
    if (!isValidPhoneNumber(data.phone)) {
      this.toastr.error('Enter correct phone number' , 'Error!');
    } else if (!isValidPhoneNumber(data.mobile)) {
      this.toastr.error('Enter correct mobile number' , 'Error!');
    } else if (!this.checkUserLogin(data)) {
      return;
    } else {
      this.userService.addUser(data).subscribe((res) => {
        if (res) {
          this.toastr.success('User added', 'Success!');
          this.userService.addSuccess = true;
          this.router.navigate([ './pages/frontusers' ]);
        }
      });
    }
  }

  changeColor (event) {
    console.log(event);
  }

  setImg(img){
    this.uploadedImg = img;
  }
}
